/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
import PropTypes from 'prop-types';
import React from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { isLocal } from '../../reducers/localId/localId';
import './WorkOrderList.css';

// eslint-disable-next-line object-curly-newline
const WorkOrderList = ({ workOrders, url }) => (
  <span>
    <ListGroup>
      { workOrders.map(({ wo_date, id, status, project: { name }, employee }) => {
        const submitted = status === 'submitted';
        const approved = status === 'approved';
        let style;
        if (isLocal(id)) style = 'danger';
        if (submitted) style = 'info';
        if (approved) style = 'success';

        return (
          <ListGroupItem
            href={`${url}/workorders/${id}`}
            bsStyle={style}
            key={id}
            className="clearfix"
          >
            ({wo_date}) &nbsp;&nbsp;&nbsp; {name}
            {isLocal(id) && <span className="pull-right" >{employee.name} &nbsp;&nbsp;&nbsp; NOT SAVED</span> }
            {submitted && <span className="pull-right" >{employee.name} &nbsp;&nbsp;&nbsp; Submitted</span> }
            {approved && <span className="pull-right" >{employee.name} &nbsp;&nbsp;&nbsp; Approved</span> }
          </ListGroupItem>);
      }) }
    </ListGroup>
  </span>
);

WorkOrderList.defaultProps = {
  workOrders: [],
};

WorkOrderList.propTypes = {
  workOrders: PropTypes.arrayOf(PropTypes.shape({})),
  url: PropTypes.string.isRequired,
};

export default WorkOrderList;



// WEBPACK FOOTER //
// ./src/components/WorkOrderList/WorkOrderList.jsx